import {ENDPOINT_VERSIONS} from './_endpoint-versions';

export const SALES_PROFILE_GET_ENDPOINT = `/${ENDPOINT_VERSIONS.V2}/sales-profiles`;
